import React, { useState, useRef } from 'react';
import InfoTracking from '@app/components/common/InfoTracking';
import { Button, Col, Switch, DatePicker, Drawer, Form, Input, Row, Select, InputNumber, Space, message, Modal } from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { insertDetail, getDetail, updateDetail } from '../../../../../apis/DefinicionPolizaApi';
import { getAll } from '../../../../../apis/ConceptoApi';
import { getList as getAllAnalitica } from '../../../../../apis/OdooAnaliticaApi';
import { getList as getAllCuenta } from '../../../../../apis/OdooCuentaApi';
import './styles.scss';

const { Option } = Select;

const normalizeSearchText = (value) =>
    (value || '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();

const App = ({ title, definicionPolizaId, id, open, finish }) => {
    const [form] = Form.useForm()
    const [ID, setID] = useState(id);
    const [showModal, setShowModal] = useState(false);
    const [initialValues, setInitialValues] = useState(null);
    const [conceptos, setConceptos] = useState([]);
    const [analiticas, setAnaliticas] = useState([]);
    const [cuentas, setCuentas] = useState([]);
    const [concepto, setConcepto] = useState(null);
    const [analitica, setAnalitica] = useState(null);
    const [cuenta, setCuenta] = useState(null);
    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if (!values) return;
            if (!concepto) {
                message.error('Es necesario seleccionar un concepto');
                return;
            }

        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
            return;
        }

        const fields = form.getFieldsValue()
        var defaultValue = {}

        // Modificado para manejar el caso cuando analitica es un objeto o un ID simple
        const analiticaValue = fields.analitica_id ?
            (typeof fields.analitica_id === 'object' ? fields.analitica_id.id : fields.analitica_id) :
            null;

        // Manejo similar para cuenta_id
        const cuentaValue = fields.cuenta_id ?
            (typeof fields.cuenta_id === 'object' ? fields.cuenta_id.id : fields.cuenta_id) :
            null;

        let success = false;
        if (ID > 0) {
            const payload = {
                id: ID,
                definicion_poliza_id: definicionPolizaId,
                ...defaultValue,
                ...fields,
                clave_concepto: concepto.clave,
                analitica_id: analiticaValue,
                cuenta_id: cuentaValue
            }
            const response = await updateDetail(payload);
            success = response.ok;
            if (response.ok) {
                message.success('Se guardo correctamente la linea!');
            }
        } else {
            const payload = {
                definicion_poliza_id: definicionPolizaId,
                ...fields,
                clave_concepto: concepto.clave,
                analitica_id: analiticaValue,
                cuenta_id: cuentaValue
            }
            const response = await insertDetail(payload);
            success = response.ok;
            if (response.ok) {
                message.success('Se guardo correctamente la linea!');
            }
        }

        if (success) {
            setShowModal(false);
            finish(true);
        }
    }

    const onClose = () => {
        setShowModal(false);
        finish(false);
    }

    React.useEffect(() => {
        setShowModal(open);
    }, [open]);

    React.useEffect(() => {
        setID(id);
        if (open && id !== ID) {
            form.resetFields();
        }
    }, [id, open]);


    const effectRan = useRef(false);
    React.useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                await getCatalogs();
                if (ID > 0) {
                    await refreshData();
                } else {
                    setInitialValues({
                        cuenta_id: undefined,
                        analitica_id: undefined,
                        activo: true,
                        usar_analitica: false
                    });
                }
            })()
        }

        return () => effectRan.current = true;
    }, [ID]);

    React.useEffect(() => {
        if (conceptos.length > 0 && initialValues && initialValues.concepto) {
            const conceptoSeleccionado = conceptos.find(c => c.value === initialValues.concepto);
            if (conceptoSeleccionado) {
                setConcepto(conceptoSeleccionado);
            }
        }

        if (analiticas.length > 0 && initialValues && initialValues.analitica_id) {
            const analiticaId = typeof initialValues.analitica_id === 'object' ?
                initialValues.analitica_id.id : initialValues.analitica_id;

            const analiticaSeleccionada = analiticas.find(a => a.value === analiticaId);
            if (analiticaSeleccionada) {
                setAnalitica(analiticaSeleccionada);
            }
        }

        if (cuentas.length > 0 && initialValues && initialValues.cuenta_id) {
            const cuentaId = typeof initialValues.cuenta_id === 'object' ?
                initialValues.cuenta_id.id : initialValues.cuenta_id;

            const cuentaSeleccionada = cuentas.find(c => c.value === cuentaId);
            if (cuentaSeleccionada) {
                setCuenta(cuentaSeleccionada);
            }
        }

        // Si initialValues cambia, actualizar el formulario
        if (initialValues) {
            form.setFieldsValue(initialValues);
        }
    }, [conceptos, analiticas, cuentas, initialValues]);

    const refreshData = async () => {
        if (ID > 0) {
            const response = await getDetail(ID);
            if (response.ok) {
                let detail = response.payload;

                // Normalizar los nombres de campos para evitar inconsistencias
                if (detail.analitica && !detail.analitica_id) {
                    detail.analitica_id = detail.analitica;
                    delete detail.analitica;
                }

                // Asegurarse de que usar_analitica tenga un valor basado en si hay analitica
                if (detail.analitica_id) {
                    detail.usar_analitica = true;
                }

                // Renombrar cuenta a cuenta_id si existe
                if (detail.cuenta && !detail.cuenta_id) {
                    detail.cuenta_id = detail.cuenta;
                    delete detail.cuenta;
                }

                console.log('Detail cargado:', detail);
                setInitialValues(detail);
            }
        } else {
            setInitialValues({
                activo: true,
                usar_analitica: false
            });
        }
    }

    const getCatalogs = async () => {
        // Obtener conceptos
        const responseConceptos = await getAll();
        if (responseConceptos.ok) {
            let items = responseConceptos.payload.map(item => ({
                value: item.id,
                text: item.displayTitle || `(${item.clave}) ${item.descripcion}`,
                clave: item.clave,
                originalData: item
            }));
            setConceptos(items);
        }

        // Obtener analíticas activas
        const responseAnaliticas = await getAllAnalitica();
        if (responseAnaliticas.ok) {
            let analiticasItems = responseAnaliticas.payload.map(item => ({
                value: item.id,
                text: item.name,
                id: item.id,
                originalData: item
            }));
            setAnaliticas(analiticasItems);
            console.log('Analíticas cargadas:', analiticasItems);
        }

        // Obtener cuentas
        const responseCuentas = await getAllCuenta();
        if (responseCuentas.ok) {
            let cuentasItems = responseCuentas.payload.map(item => ({
                value: item.id,
                text: item.display_name || `${item.code} - ${item.name}`,
                id: item.id,
                originalData: item
            }));
            setCuentas(cuentasItems);
            console.log('Cuentas cargadas:', cuentasItems);
        }
    }

    const changeConcepto = async (value) => {
        var _concepto = conceptos.find(x => x.value == value);

        if (_concepto) {
            setConcepto(_concepto);

            const currentValues = form.getFieldsValue();
            form.setFieldsValue({
                ...currentValues,
                clave_concepto: _concepto.clave
            });

            console.log("Concepto cambiado:", _concepto);
        } else {
            console.warn("No se encontró el concepto con ID:", value);
        }
    }

    const changeAnalitica = async (value) => {
        var _analitica = analiticas.find(x => x.value == value);

        if (_analitica) {
            setAnalitica(_analitica);
            console.log("Analítica cambiada:", _analitica);
        } else {
            console.warn("No se encontró la analítica con ID:", value);
        }
    }

    const changeCuenta = async (value) => {
        var _cuenta = cuentas.find(x => x.value == value);

        if (_cuenta) {
            setCuenta(_cuenta);
            console.log("Cuenta cambiada:", _cuenta);
        } else {
            console.warn("No se encontró la cuenta con ID:", value);
        }
    }

    // Función para manejar el cambio en usar_analitica
    const handleUsarAnaliticaChange = (checked) => {
        if (!checked) {
            form.setFieldsValue({ analitica_id: undefined });
        }
        // Forzar una actualización del formulario
        form.setFieldsValue({ usar_analitica: checked });
    };

    return (
        <>
            <Drawer
                title={title}
                width={720}
                placement={"right"}
                onClose={onClose}
                open={open}
                closable={true}
                height={'80%'}
                onFinish={handleOk}
                styles={{
                    body: {
                        paddingBottom: 80,
                    },
                }}
                extra={[
                    <Space key="actions">
                        {ID && <InfoTracking entity={'ConfiguracionPeriodoDetalle'} entityId={ID} />}
                        <Button onClick={onClose}>Cancelar</Button>
                        <Button onClick={handleOk} type="primary">
                            Guardar
                        </Button>
                    </Space>
                ]}
            >
                {
                    initialValues &&
                    <Form layout="vertical" form={form} hideRequiredMark onFinish={handleOk} initialValues={initialValues}>
                        <Row gutter={16}>
                            <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                <Form.Item
                                    name="concepto"
                                    label="Concepto"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor selecciona un concepto',
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder="Por favor selecciona un concepto"
                                        onChange={changeConcepto}
                                    >
                                        {
                                            conceptos.map((item) => <Option key={item.value} value={item.value}>{item.text}</Option>)
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                <Form.Item
                                    name="tipo_cuenta"
                                    label="Tipo de Cuenta"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor selecciona un Tipo de Cuenta',
                                        },
                                    ]}
                                >
                                    <Select placeholder="Selecciona Cargo o Abono">
                                        <Option value={0}>Cargo</Option>
                                        <Option value={1}>Abono</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                                <Form.Item
                                    name="cuenta_id"
                                    label="Cuenta"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor selecciona una cuenta',
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder="Por favor selecciona una cuenta"
                                        onChange={changeCuenta}
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) => {
                                            const normalizedInput = normalizeSearchText(input);
                                            const optionText = normalizeSearchText(option?.children);
                                            return optionText.includes(normalizedInput);
                                        }}
                                        filterSort={(optionA, optionB, { searchValue }) => {
                                            const normalizedSearch = normalizeSearchText(searchValue);
                                            const textA = normalizeSearchText(optionA?.children);
                                            const textB = normalizeSearchText(optionB?.children);

                                            const startsWithA = textA.startsWith(normalizedSearch);
                                            const startsWithB = textB.startsWith(normalizedSearch);

                                            if (startsWithA !== startsWithB) {
                                                return startsWithA ? -1 : 1;
                                            }

                                            const includesA = textA.includes(normalizedSearch);
                                            const includesB = textB.includes(normalizedSearch);

                                            if (includesA !== includesB) {
                                                return includesA ? -1 : 1;
                                            }

                                            return textA.localeCompare(textB);
                                        }}
                                        style={{ width: '80%', }}
                                    >
                                        {
                                            cuentas.map((item) => <Option key={item.value} value={item.value}>{item.text}</Option>)
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col md={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                <Form.Item
                                    name="generar"
                                    label="Generar"
                                    valuePropName="checked"
                                >
                                    <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />} />
                                </Form.Item>
                            </Col>
                            <Col md={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                <Form.Item
                                    name="signo"
                                    label="Signo"
                                    valuePropName="checked"
                                >
                                    <Switch checkedChildren="+" unCheckedChildren="-" />
                                </Form.Item>
                            </Col>
                            <Col md={{ span: 6 }} sm={{ span: 6 }} xs={{ span: 24 }}>
                                <Form.Item
                                    name="usar_analitica"
                                    label="Usar Analitica"
                                    valuePropName="checked"
                                >
                                    <Switch
                                        checkedChildren={<CheckOutlined />}
                                        unCheckedChildren={<CloseOutlined />}
                                        onChange={handleUsarAnaliticaChange}
                                    />
                                </Form.Item>
                            </Col>
                            <Col md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                                <Form.Item
                                    name="analitica_id"
                                    label="Analítica"
                                >
                                    <Select
                                        placeholder="Por favor selecciona una analítica"
                                        onChange={changeAnalitica}
                                        style={{ width: '80%' }}
                                        allowClear
                                        onClear={() => {
                                            setAnalitica(null);
                                            console.log("Analítica limpiada");
                                        }}
                                    >
                                        {
                                            analiticas.map((item) => <Option key={item.value} value={item.value}>{item.text}</Option>)
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                <Form.Item
                                    name="activo"
                                    label="Activo"
                                    valuePropName="checked"
                                >
                                    <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                }
            </Drawer>
        </>
    );
};

export default App;